import { Input } from 'formik-antd';
import styled from 'styled-components';
import { Form as AntForm } from 'antd';

const sharedInputContainerStyles = `
  input:focus{
    border-color: #198754;
    box-shadow: 0 0 0 0.5px #198754;
    border-right-width: 1px;
    outline: 0;
  }

  input:hover {
    border-color: #198754;
    border-right-width: 1px;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #198754;
    border-right-width: 0.5px;
    z-index: 1;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):focus {
    box-shadow: 0 0 0 0.5px #198754;
    border-right-width: 1px;
    outline: 0;
    z-index: 1;
  }

  &.ant-form-item-has-error input.ant-input.ant-input-status-error:focus,
  &.ant-form-item-has-error input.ant-input.ant-input-status-error:focus-visible,
  &.ant-form-item-has-error input.ant-input.ant-input-status-error:focus-within,
  &.ant-form-item-has-error .ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):focus,
  &.ant-form-item-has-error .ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):focus-within,
  &.ant-form-item-has-error .ant-input-affix-wrapper.ant-input-affix-wrapper-status-error.ant-input-affix-wrapper-focused {
    outline: 2px solid #111;
    outline-offset: 3px;
  }
`;

export const InputStyled = styled(Input)`
  border-radius: 10px;
  align-items: center;
  border: solid 0.5px #959595;
  background-color: #fff;
  padding: 1em;`;

export const AccessibleFormItemStyled = styled(AntForm.Item)`
  ${sharedInputContainerStyles}
`;

export const FieldHintText = styled.p`
  margin: 0.35rem 0 0;
  color: #595959;
  font-size: 0.875rem;
`;

export const FieldErrorAlert = styled.div`
  margin: 0;
`;

export const FieldErrorText = styled.p`
  margin: 0.35rem 0 0;
  color: #CC0003;
`;
